import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TableBody,
  TableContainer,
} from '@mui/material';
import ListViewHeader from './ListViewHeader';
import ListViewItem from './ListViewItem';
import MediaViewer from 'shared/components/MediaViewer';
import { getFileSize } from '@crema/utility/Utils';
import { useDispatch } from 'react-redux';
import {
  onChangeFilter,
  onExportSK,
  onGetApprovalSK,
  onGetCompletedDigisign,
  onGetCompletedDigisignSk,
  onGetComposerDigisign,
  onGetDraftDigisign,
  onGetMonitoringListDigisign,
  onGetNeedSignSK,
  onGetRejectedDigisignSk,
  onGetRevisiDigisignSk,
  onGetSignedDigisign,
  onUpdateSignDigisign,
} from 'redux/actions/DigitalSign';
import { useLocation, useNavigate } from 'react-router-dom';
import { ButtonContained } from 'shared/components/Button';
import AppsPagination from '@crema/core/AppsPagination';
import { COLORS } from 'shared/constants/AppEnums';
import AppSearch from '@crema/core/AppSearchBar';
import DialogSignDetail from '../../Dialog/DialogSignDetail';
import { grey } from '@mui/material/colors';
import { StyledTable } from 'shared/components/Table';
import TableEmptyResult from 'shared/components/Table/TableEmptyResult';
import moment from 'moment';
import AppCard from '@crema/core/AppCard';
import { useAuthUser, useAuthMethod } from '@crema/utility/AuthHooks'
import DialogKonfirmasi from 'shared/components/DialogKonfirmasi'

const filterOption = [
  { value: 'sk-completed', label: 'Inbox' },
  { value: 'draft', label: 'Draft' },
  { value: 'composer', label: 'List Saya' },
  { value: 'revisi', label: 'Revisi' },
  { value: 'sk-need-sign', label: 'Need Sign' },
  { value: 'sk-need-approval', label: 'Need Approval' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'completed', label: 'Signed' },
];

const filterMonitoringOption = [
  { value: 'sk-completed', label: 'Inbox' },
  { value: 'monitoring', label: 'Monitoring' },
];

const ListView = ({ setRefresh, tipeDokumen }) => {
  const filterEl = useRef(null);
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const { pathname } = useLocation();
  const { setUser } = useAuthMethod()
  const { user } = useAuthUser()

  const { profileMe } = useSelector((state) => state.profile);
  const { lists, filter } = useSelector((state) => state.digiSign);

  const [index, setIndex] = useState(-1);
  const [checked, setChecked] = useState([]);
  const [searchVal, setSearchVal] = useState('');
  const [isCreate, setIsCreate] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [isApprover, setIsApprover] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [filteredOption, setFilteredOption] = useState([]);
  const [monitoringRole, setMonitoringRole] = useState(false);
  const [bulkDigiSignRole, setBulkDigiSignRole] = useState(false);
  const [modalConfSubmitBulk, setModalConfSubmitBulk] = useState(false)
  const [page, setPage] = useState({
    value: 0,
    refresh: false,
  });
  const [error, setError] = useState({
    passphrase: false,
  });
  const [stateDialog, setStateDialog] = useState({
    passphrase: '',
    komentar: '',
    isBypass: true
  });

  const isBypass = user.roles_coofis.some(item => item.state === 'BYPASS_PASSPHRASE')

  const handleChangeDialog = (name, value) => {
    setStateDialog({
      ...stateDialog,
      [name]: value,
    });
  };

  const handleValidation = () => {
    let pass;
    if (stateDialog.passphrase === '') pass = true;
    else pass = false;
    setError({
      ...error,
      passphrase: pass,
    });
  };

  const handleSubmitSign = () => {
    handleValidation();
    if (stateDialog.passphrase !== '' || user.is_bypass) {
      // function to submit passphrase here
      const payload = {
        passphrase: stateDialog.passphrase,
        id_documents: selectedRow,
        comment: 'Dokumen sudah di tanda tangan',
        sign_date: moment().format('DD MMMM YYYY'),
        is_bypass: isBypass && stateDialog.isBypass ? 'true' : 'false'
      };
      dispatch(
        onUpdateSignDigisign(
          payload,
          () => {
            setUser({
              ...user,
              is_bypass: isBypass && stateDialog.isBypass ? true : false
            })
            setSelectedRow([])
            setRefresh(true)
          },
          'dokumen-sk',
          () => {
            setUser({
              ...user,
              is_bypass: false
            })
          }
        ),
      );

      setStateDialog({
        passphrase: '',
        komentar: '',
        isBypass: true
      });
      setError({
        passphrase: false,
        komentar: false,
      });
      setChecked([]);
      setOpenDialog(false);
    }
  };

  const handleChangeFilter = (state) => {
    dispatch(onChangeFilter(state));
    if (filterEl.current) {
      filterEl.current.value = ''; // Set the input value to an empty string
    }
  };

  const handleExportSk = () => {
    dispatch(onExportSK('done'))
  }

  const setDocumentType = (input) => {
    switch (input) {
      case 'sdmao':
        return 'dokumen_sk';
      case 'ppid':
        return 'dokumen_ppid';
      case 'dirjend':
        return 'dokumen_dirjend';
      default:
        return 'dokumen_sk';
    }
  };

  const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
  };

  const handleShowAttachment = (index) => {
    setIndex(index);
  };

  const onCloseShowAttachment = () => {
    setIndex(-1);
  };

  const onPageChange = (event, value) => {
    setPage({
      value: value,
      refresh: true,
    });
  };

  const handleBulkProsesTtd = () => {
    let data = {
      passphrase: '',
      id_documents: selectedRow,
      sign_date: moment().format('DD MMMM YYYY'),
    };
    dispatch(onApproveDocumentDigisign(data));
  };

  const debounce = (func, wait) => {
    let timeout;

    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  const onGetFilteredItems = async (tipe, inputVal) => {
    console.log('filter', filter)
    console.log('tipe', tipe)
    try {
      setSearchVal(inputVal);
      setPage({
        value: 0,
        refresh: false,
      });
      if (tipe === 'composer') {
        dispatch(onGetComposerDigisign(setDocumentType(tipeDokumen), inputVal));
      } else if (tipe === 'sk-need-approval')
        dispatch(onGetApprovalSK(setDocumentType(tipeDokumen), inputVal));
      else if (tipe === 'sk-need-sign')
        dispatch(onGetNeedSignSK(setDocumentType(tipeDokumen), inputVal));
      else if (tipe === 'draft') {
        dispatch(onGetDraftDigisign(setDocumentType(tipeDokumen), inputVal));
      } else if (tipe === 'signed') {
        dispatch(onGetSignedDigisign(setDocumentType(tipeDokumen), inputVal));
      } else if (filter === 'rejected') {
        dispatch(onGetRejectedDigisignSk(setDocumentType(tipeDokumen), inputVal));
      } else if (filter === 'revisi') {
        dispatch(onGetRevisiDigisignSk(setDocumentType(tipeDokumen), inputVal));
      } else if (tipe === 'monitoring') {
        dispatch(onGetMonitoringListDigisign(setDocumentType(tipeDokumen), inputVal));
      } else {
        dispatch(onGetCompletedDigisign(setDocumentType(tipeDokumen), inputVal, 0, 10));
      }
    } catch (e) {
      console.log(e);
    }
  };

  const onHandleSearch = debounce(
    (tipe, inputVal) => onGetFilteredItems(tipe, inputVal),
    500,
  );

  useEffect(() => {
    if (profileMe) {
      const createRole =
        profileMe.roles_coofis.findIndex((x) => x.state === 'DIGISIGN.SK') > -1
          ? true
          : false;
      const filterRole =
        profileMe.roles_coofis.findIndex(
          (x) => x.state === 'APPROVER.DIGISIGN.SK',
        ) > -1
          ? true
          : false;
      const monitoringRole =
        profileMe.roles_coofis.findIndex(
          (x) => x.state === 'MONITORING_DIGITAL_SIGN',
        ) > -1
          ? true
          : false;
      const bulkDigiSignRole =
        profileMe.roles_coofis.findIndex((x) => x.state === 'BULK_DIGISIGN') >
          -1
          ? true
          : false;
      setIsApprover(filterRole);
      setIsCreate(createRole);
      setMonitoringRole(monitoringRole);
      setBulkDigiSignRole(bulkDigiSignRole);
    }
  }, [profileMe]);

  useEffect(() => {
    let createRole;
    if (tipeDokumen === 'sdmao') {
      createRole = profileMe.roles_coofis.findIndex((x) => x.state === 'DIGISIGN.SK') > -1
        ? true
        : false;
    } else if (tipeDokumen === 'ppid') {
      createRole = profileMe.roles_coofis.findIndex((x) => x.state === 'DIGISIGN.SK.PPID') > -1
        ? true
        : false;
    } else if (tipeDokumen === 'dirjend') {
      createRole = profileMe.roles_coofis.findIndex((x) => x.state === 'DIGISIGN.SK.DIRJEN') > -1
        ? true
        : false;
    }
    setIsCreate(createRole)
  }, [tipeDokumen])

  useEffect(() => {
    const temp = [...filterOption]
    if (isApprover || isCreate) {
      setFilteredOption(temp);
    } else if (monitoringRole) {
      setFilteredOption(filterMonitoringOption);
    } else {
      setFilteredOption(temp.splice(0, 1));
    }
  }, [isApprover, isCreate, monitoringRole]);

  useEffect(() => {
    if (filteredOption.length === 1) {
      handleChangeFilter('sk-completed')
    } else if (monitoringRole) {
      handleChangeFilter('monitoring');
    } else {
      handleChangeFilter('composer');
    }
  }, [filteredOption]);

  useEffect(() => {
    if (page.refresh) {
      if (filter === 'composer') {  // get composer digisign
        dispatch(onGetComposerDigisign(setDocumentType(tipeDokumen), searchVal, page.value + 1));
      } else if (filter === 'sk-need-approval') {   // get approval sk
        dispatch(onGetApprovalSK(setDocumentType(tipeDokumen), searchVal, page.value + 1, 10));
      } else if (filter === 'sk-need-sign') {   // get need sign sk
        dispatch(onGetNeedSignSK(setDocumentType(tipeDokumen), searchVal, page.value + 1, 10));
      } else if (filter === 'sk-completed') {   // get completed digisign sk
        dispatch(onGetCompletedDigisignSk(setDocumentType(tipeDokumen), searchVal, page.value + 1));
      } else if (filter === 'draft') { // get draft digisign
        dispatch(onGetDraftDigisign(setDocumentType(tipeDokumen), searchVal, page.value + 1));
      } else if (filter === 'completed') { // get completed digisign 
        dispatch(onGetCompletedDigisign(setDocumentType(tipeDokumen), searchVal, page.value + 1, 10));
      } else if (filter === 'rejected') {   // get rejected digisign sk
        dispatch(onGetRejectedDigisignSk(searchVal, page.value + 1));
      } else if (filter === 'signed') {   // get signed digisign sk
        dispatch(onGetSignedDigisign(setDocumentType(tipeDokumen), searchVal, page.value + 1));
      } else if (filter === 'revisi') {   // get revisi digisign sk
        dispatch(onGetRevisiDigisignSk(setDocumentType(tipeDokumen), searchVal, page.value + 1));
      } else if (filter === 'monitoring') {   // get monitoring digisign sk
        dispatch(onGetMonitoringListDigisign(setDocumentType(tipeDokumen), searchVal, page.value + 1));
      }
    }
  }, [page, searchVal, tipeDokumen]);

  useEffect(() => {
    if (pathname === '/apps/dokumen-sk') {
      setPage({
        value: 0,
        refresh: false,
      });
    }
  }, [filter, pathname]);

  return (
    <>
      <AppCard
        sxStyle={{
          width: '100%',
          minHeight: '80vh !important',
        }}
        contentStyle={{
          padding: '0 !important',
          backgroundColor: 'white',
          display: 'flex !important',
          flexDirection: 'column !important'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            flex: 1,
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingY: 2,
            paddingX: 5,
          }}
        >
          <Stack
            direction='row'
            width={{ xs: '100%', md: 'auto' }}
            gap={{ xs: 12, sm: 6 }}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            {(isCreate || monitoringRole) && (
              <ButtonContained
                onClick={() => navigation('/apps/dokumen-sk/tambah-dokumen/' + tipeDokumen)}
              >
                + Tambah Dokumen
              </ButtonContained>
            )}

            {monitoringRole && (
              <ButtonContained
                disabled={filter !== 'monitoring'}
                onClick={() => handleExportSk()}
              >
                Export
              </ButtonContained>
            )}

            {bulkDigiSignRole && filter == 'sk-need-sign' && selectedRow.length > 0 && (
              <ButtonContained onClick={() => {
                if (user.is_bypass) {
                  setModalConfSubmitBulk(true)
                } else {
                  setOpenDialog(true)
                }
              }}>
                Bulk Proses TTD
              </ButtonContained>
            )}

            <AppsPagination
              sx={{
                paddingRight: 2,
                paddingLeft: 2,
                '& .MuiToolbar-root': {
                  paddingLeft: 0,
                },
                '& .MuiTablePagination-actions': {
                  marginLeft: '0 !important',
                  '& .MuiButtonBase-root': {
                    padding: 2,
                  },
                },
              }}
              count={lists ? lists?.count : 0}
              rowsPerPage={10}
              page={page.value}
              labelDisplayedRows={({ from, to, count }) =>
                ` ${from}-${to} dari ${count}`
              }
              onPageChange={onPageChange}
            />
          </Stack>

          <Stack
            gap={6}
            direction='row'
            alignItems={'center'}
            justifyContent={'space-between'}
            width={{ xs: '100%', md: 'auto' }}
            sx={{
              '& label.Mui-focused': {
                color: COLORS.primary,
              },
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: grey[500],
                },
                '&.Mui-focused fieldset': {
                  borderColor: COLORS.primary,
                  color: COLORS.primary,
                },
              },
            }}
          >
            {/* Filter */}
            <FormControl sx={{ m: 1, minWidth: 120 }} size='small'>
              <InputLabel id='filter-list'>Filter</InputLabel>
              <Select
                labelId='filter-list'
                id='filter-list-id'
                label='Filter'
                value={filter}
                onChange={(e) => handleChangeFilter(e.target.value)}
              >
                {filteredOption &&
                  filteredOption.length > 0 &&
                  filteredOption.map((x, index) => (
                    <MenuItem key={index} value={x.value}>
                      {' '}
                      {x.label}{' '}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>

            {/* Search Bar */}
            <AppSearch
              iconPosition={'right'}
              overlap={false}
              placeholder={'Cari Disini...'}
              inputRef={filterEl}
              onChange={() => {
                onHandleSearch(filter, filterEl.current?.value);
              }}
              sx={{
                '&.MuiInputBase-root .MuiInputBase-input': {
                  paddingLeft: 4,
                  backgroundColor: grey[100],
                  width: {
                    xs: '180px',
                    md: '200px',
                  },
                },
                '&.MuiInputBase-root .MuiInputBase-input:focus': {
                  width: {
                    xs: '180px',
                    md: '240px',
                  },
                },
              }}
            />
          </Stack>
        </Box>

        {/* Table List */}
        <Stack sx={{ height: '100%', overflow: 'auto' }}>
          <TableContainer className='custom-scrollbar'>
            <StyledTable stickyHeader aria-label='customize table'>
              <ListViewHeader filter={filter} isCreate={isCreate} isMonitoring={monitoringRole} />
              <TableBody>
                {lists !== null &&
                  lists?.results.map((data, i) => (
                    <ListViewItem
                      no={page.value}
                      index={i}
                      setSelectedRow={setSelectedRow}
                      selectedRow={selectedRow}
                      key={data.id}
                      data={data}
                      id={data.id}
                      lists={lists}
                      tipeDokumen={tipeDokumen}
                      handleShowAttachment={handleShowAttachment}
                      isCreate={isCreate}
                      isMonitoring={monitoringRole}
                      setRefresh={() => setPage(prev => ({ ...prev, refresh: true }))}
                    />
                  ))}
                <TableEmptyResult list={lists?.results} />
              </TableBody>
            </StyledTable>
          </TableContainer>
        </Stack>
      </AppCard>

      {/* Modal Sign */}
      <DialogSignDetail
        error={error}
        open={openDialog}
        state={stateDialog}
        title={'Masukkan Paraphrase'}
        handleSubmit={handleSubmitSign}
        onChangeState={handleChangeDialog}
        handleClose={() => {
          setError({
            passphrase: false,
            komentar: false,
          });
          setStateDialog({
            passphrase: '',
            komentar: '',
            isBypass: true
          });
          setOpenDialog(false);
        }}
      />

      {/* Dialog Confirm */}
      <DialogKonfirmasi
        open={modalConfSubmitBulk}
        handleClose={(status = 0) => {
          if (status === 1) {
            handleSubmitSign()
          }
          setModalConfSubmitBulk(false)
        }}
        labelPesan={'Tanda Tangan Dokumen'}
        isiPesan={`Apakah anda yakin akan menandatangani dokumen ini?`}
        labelTombol='Ya'
      />

      {/* Media Viewer */}
      {index >= 0 ? (
        <MediaViewer
          index={index}
          medias={{
            url: lists.results[index].attachments[0].file,
            mime_type: getFileExtension(
              lists.results[index].attachments[0].name,
            ),
            name: lists.results[index].attachments[0].name,
            size: getFileSize(lists.results[index].attachments[0].file_size),
          }}
          onClose={onCloseShowAttachment}
        />
      ) : null}
    </>
  );
};

ListView.propTypes = {
  setRefresh: PropTypes.func,
  tipeDokumen: PropTypes.string
};

export default ListView;
